import { createContext, useContext, useState } from 'react'
import type { ConversationIllustrationInfo } from '../interfaces/ConversationIf'

export const useConversation = () => {
  return useContext(authContext)
}

interface UseConversation {
  convId: string
  orgText: boolean
  illustrationIds: ConversationIllustrationInfo[]
  setConvId: (convId: string) => void
  setOrgText: (orgText: boolean) => void
  setIllustrationIds: (illustrationIds: ConversationIllustrationInfo[]) => void
}

const authContext = createContext({} as UseConversation)

type Props = {
  children: React.ReactNode
}

// 認証プロバイダ
export const ProvideConversation: React.FC<Props> = ({ children }) => {
  const conv = useProvideConversation()
  return <authContext.Provider value={conv}>{children}</authContext.Provider>
}

const useProvideConversation = (): UseConversation => {
  const [convId, setConvId] = useState('')
  const [orgText, setOrgText] = useState(true)
  const [illustrationIds, setIllustrationIds] = useState<ConversationIllustrationInfo[]>([])

  return {
    convId,
    orgText,
    illustrationIds,
    setConvId,
    setOrgText,
    setIllustrationIds,
  }
}
